import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function AllBuying() {

    const navigate = useNavigate();

    const [uichange, setuichange] = useState(false);

    useEffect(() => {
        getAllPurchased();
    }, [uichange])

    const [purchases, setPurchases] = useState([])
    const getAllPurchased = async () => {
        try {
            const response = await axios.get("/buy/");
            if (response.data.success) {
                setPurchases(response.data.buyings)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }


    const handleDelete = async (id) => {
        const sure = window.confirm("Are you sure you want to delete");
        if (!sure) {
            return;
        }

        try {
            const response = await axios.delete(`/buy/${id}`);
            if (response.data.success) {
                toast.success(response.data.message);
                setuichange(!uichange);
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    return (
        <div className='mx-4 mt-5'>
            <table className="table w-[95%] mx-auto mt-7 overflow-auto">
                {/* head */}
                <thead className="bg-blue-800 text-white">
                    <tr className="text-lg">
                        <th></th>
                        <th className="text-xl">Date</th>
                        <th className="text-xl">Distributor Name</th>
                        <th className="text-xl">Contact</th>
                        <th className="text-xl">Address</th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>

                <tbody className="border-2 border-blue-400">

                    {
                        purchases?.map((p, index) => {
                            return (
                                <tr className="text-base cursor-pointer hover:bg-blue-100" key={p._id}>
                                    <th className="text-black font-bold">{index + 1}</th>
                                    <td className="text-blue-700 font-bold">{new Date(p.date).toLocaleDateString("en-In")}</td>
                                    <td className="text-blue-700 font-bold">{p?.distributor?.name}</td>
                                    <td className="text-blue-700 font-bold">{p?.distributor?.contact}</td>
                                    <td className="text-blue-700 font-bold">{p?.distributor?.address}</td>
                                    <td>
                                        <i
                                            onClick={() =>
                                                navigate(`/buying/update/${p._id}`)
                                            }
                                            class="fa-solid fa-pen-to-square hover:scale-125 bg-green-700 text-white p-3 rounded-full cursor-pointer"
                                        ></i>
                                    </td>
                                    <td>
                                        <i
                                            onClick={() => handleDelete(p._id)}
                                            class="fa-solid fa-trash hover:scale-125 bg-red-500 text-white p-3 rounded-full cursor-pointer"
                                        ></i>
                                    </td>
                                    <td className=' text-blue-700 font-bold'>
                                        <i onClick={() => navigate(`/buying/view/${p._id}`)} class="fa-solid fa-circle-info hover:scale-125 cursor-pointer bg-blue-700 text-white p-3 rounded-full"></i>
                                    </td>
                                </tr>
                            )
                        })
                    }


                </tbody>

            </table>
        </div>
    )
}

export default AllBuying
